import { CurrentUserAvatar } from './CurrentUserAvatar';
import React from 'react';
import { useAuthToken } from '@hooks';
import { administrationMenuItem, helpMenuItem, logoutMenuItem, settingsMenuItem, termsMenuItem } from './menuitems';
import { Dropdown, Space } from 'antd';
import { SonarMenu } from '@ui/menu';
const menuItems = [
    administrationMenuItem,
    settingsMenuItem,
    helpMenuItem,
    termsMenuItem,
    logoutMenuItem
];
export const UserMenu = () => {
    const { isAdmin } = useAuthToken();
    const menu = React.createElement(SonarMenu, { id: 'user-menu', items: isAdmin ? menuItems : menuItems.slice(1) });
    return (React.createElement(Dropdown, { popupRender: () => menu, trigger: ['click'] },
        React.createElement(Space, null,
            React.createElement(CurrentUserAvatar, null))));
};
